import { Button as n } from "../../../../components/Button/index.js";
import { Icon as i } from "../../../../components/Icon/index.js";
import { styled as o } from "styled-components";
import { MediaQuery as r } from "../../../../styles/variables.js";
import { Theme as t } from "../../../../styles/themes/index.js";
import { H3Heavy as e, H2Heavy as a, Body as l, CaptionLight as p } from "../../../../styles/typography/index.js";
const y = o.p`
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  ${e}
  color: rgb(${t.colors.Alpha});
  margin-bottom: 24px;

  @media ${r.SCREEN_MD_UP} {
    ${a}
  }
`, f = o.label`
  ${l}

  margin-top: 8px;
  display: block;

  > span {
    ${p}
    margin-bottom: 4px;
    display: inline-block;
    padding-left: 12px;
  }
`, b = o(n)`
  height: 48px;
  width: 100%;
`, H = o.div`
  margin-bottom: 57px;

  &[data-invalid='true'] {
    margin-bottom: 24px;
  }
`, $ = o(i)`
  align-self: center;
  font-size: 48px;
  margin-bottom: 16px;
  color: rgb(${t.colors.Brand});
`;
export {
  H as FormBody,
  b as HyperLinkModalButton,
  f as HyperLinkModalLabel,
  y as HyperLinkModalTitle,
  $ as LinkIcon
};
